import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-work-lonely-planet",
  templateUrl: "./work-lonely-planet.component.html",
  styleUrls: ["./work-lonely-planet.component.scss"],
})
export class WorkLonelyPlanetComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  //Image 100% width container
  imgContainerAlt = "Mapping Image";
  imgContainerUrl = "assets/img/mapping/mapping-img-container.jpg";
  projectImgDevices = "assets/img/mapping/mapping.png";
  altImgDevicesTitle = "Mapping App Screenshots";
}



// WEBPACK FOOTER //
// ./src/app/work-lonely-planet/work-lonely-planet.component.ts